import PropTypes from 'prop-types';

import { userWithActiveFlagShape } from '../shared/propTypes/users';
import { userClientListPropTypes } from '../shared/propTypes/userClients';

export const userToEditPropTypes = PropTypes.shape({
  ...userWithActiveFlagShape,
  clients: userClientListPropTypes,
});

export const clientRolePropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  clientId: PropTypes.number.isRequired,
  roleId: PropTypes.string,
});

const businessUnitPropTypes = PropTypes.arrayOf(PropTypes.shape({
  businessUnit: PropTypes.string.isRequired,
  businessUnitDescription: PropTypes.string.isRequired,
}));

const companyCodesPropTypes = PropTypes.arrayOf(PropTypes.shape({
  companyCode: PropTypes.string.isRequired,
  companyCodeDescription: PropTypes.string,
}));

const connectionsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  connectionName: PropTypes.string.isRequired,
}));

const countriesPropTypes = PropTypes.arrayOf(PropTypes.shape({
  countryCode: PropTypes.string.isRequired,
  countryDescription: PropTypes.string.isRequired,
}));

const businessesPropTypes = PropTypes.arrayOf(PropTypes.shape({
  businessCode: PropTypes.string.isRequired,
  businessDescription: PropTypes.string.isRequired,
}));

export const userSettingsFormDataPropTypes = PropTypes.shape({
  businessUnits: PropTypes.arrayOf(PropTypes.shape({
    clientId: PropTypes.number.isRequired,
    data: businessUnitPropTypes.isRequired,
  })),
  companyCodes: PropTypes.arrayOf(PropTypes.shape({
    clientId: PropTypes.number.isRequired,
    data: companyCodesPropTypes.isRequired,
  })),
  connections: PropTypes.arrayOf(PropTypes.shape({
    clientId: PropTypes.number.isRequired,
    data: connectionsPropTypes.isRequired,
  })),
  countries: PropTypes.arrayOf(PropTypes.shape({
    clientId: PropTypes.number.isRequired,
    data: countriesPropTypes.isRequired,
  })),
  availableAssignmentPermissions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  userClientList: userClientListPropTypes.isRequired,
});

export const userSettingsFormDataPropTypesForClient = PropTypes.shape({
  businessUnits: businessUnitPropTypes.isRequired,
  companyCodes: companyCodesPropTypes.isRequired,
  connections: connectionsPropTypes.isRequired,
  countries: countriesPropTypes.isRequired,
  businesses: businessesPropTypes.isRequired,
  availableAssignmentPermissions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    requiresPermissions: PropTypes.arrayOf(PropTypes.string),
  })).isRequired,
  userClientList: userClientListPropTypes.isRequired,
});

export const roleOptionPropTypes = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
});

export const rolesOptionsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  clientId: PropTypes.number.isRequired,
  roles: PropTypes.arrayOf(roleOptionPropTypes).isRequired,
}));

export const availablePermissionPropTypes = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  notAvaialable: PropTypes.bool,
  requiredRole: PropTypes.arrayOf(PropTypes.string),
});

export const availablePermissionsForRolePropTypes = PropTypes.shape({
  clientId: PropTypes.number.isRequired,
  availablePermissions: PropTypes.shape({
    powerUser: PropTypes.arrayOf(availablePermissionPropTypes),
    superUser: PropTypes.arrayOf(availablePermissionPropTypes),
    user: PropTypes.arrayOf(availablePermissionPropTypes),
  }),
});

export const availablePermissionsPropTypes = PropTypes.arrayOf(availablePermissionsForRolePropTypes);

export const loggedInUserAssignmentsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  assignmentType: PropTypes.string.isRequired,
  assignmentCode: PropTypes.string.isRequired,
  privileges: PropTypes.arrayOf(PropTypes.string).isRequired,
  clientId: PropTypes.number.isRequired,
})).isRequired;

export const canEditClientsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  clientId: PropTypes.number.isRequired,
  canEdit: PropTypes.bool.isRequired,
}));

export const clientsFormDataPropTypes = PropTypes.arrayOf(PropTypes.shape({
  canEdit: PropTypes.bool.isRequired,
  clientId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  roleName: PropTypes.string.isRequired,
}));

export const clientExpirationDatePropTypes = PropTypes.shape({
  clientId: PropTypes.number,
  expirationDate: PropTypes.string,
});
